import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./App.css";
import logo from "./assets/Roimages/logo/Logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import CallIcon from "@mui/icons-material/Call";

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  const handleToggle = () => setExpanded(!expanded);
  const handleClose = () => setExpanded(false);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="NavSticky fixed-top p-0">
        <Navbar
          expanded={expanded}
          expand="lg"
          className="topnavmenu py-2 bg-white shadow-sm"
        >
          <Container>
            <Navbar.Brand className="p-0">
              <Link to={"/"} onClick={handleClose}>
                <img
                  alt="logo"
                  src={logo}
                  className="logo-header"
                  loading="lazy"
                />
              </Link>
            </Navbar.Brand>

            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={handleToggle}
              className="border-0 focus-ring-none"
            />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto align-items-center">
                <Link
                  to={"/"}
                  className={`navlink text-decoration-none mx-2 mb-2 mb-lg-0 ${isActive("/") ? "active" : ""}`}
                  onClick={handleClose}
                >
                  Home
                </Link>

                <Link
                  to={"/product"}
                  className={`navlink text-decoration-none mx-2 mb-2 mb-lg-0 ${isActive("/product") ? "active" : ""}`}
                  onClick={handleClose}
                >
                  Product
                </Link>

                <Link
                  to={"/blog"}
                  className={`navlink text-decoration-none mx-2 mb-2 mb-lg-0 ${isActive("/blog") ? "active" : ""}`}
                  onClick={handleClose}
                >
                  Blog
                </Link>

                <Link
                  to={"/contact"}
                  className={`navlink text-decoration-none mx-2 mb-2 mb-lg-0 ${isActive("/contact") ? "active" : ""}`}
                  onClick={handleClose}
                >
                  Contact
                </Link>

                <a
                  href="tel:+919265199516"
                  className="mobile-nav-btns text-decoration-none mx-2 d-flex align-items-center gap-1"
                >
                  <CallIcon fontSize="small" /> +91 92651 99516
                </a>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default Header;

